module.exports = __webpack_public_path__ + "media/src/StayPackage/images/chevron-right-9f5e9a4009893d839590f55355dd0832.svg";